export default __webpack_public_path__ + "static/about_shape-d824a29ddda85ff4536259537e2aaefb.png";